<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>{{ $t('about.title') }}</h1>
      <p>{{ $t('about.subtitle') }}</p>
    </section>

    <section class="company-info">
      <div class="info-content">
        <h2 v-html="$t('about.intro.title')"></h2>
        <p v-for="(paragraph, index) in paragraphs" :key="index" class="indent">
          {{ paragraph }}
        </p>
      </div>
    </section>
    <section class="company-values">
      <h2>{{ $t('about.values.title') }}</h2>
      <div class="values-grid">
        <div class="value-item">
          <div class="value-icon">创</div>
          <h3>{{ $t('about.values.items.innovation.title') }}</h3>
          <p>{{ $t('about.values.items.innovation.desc') }}</p>
        </div>
        <div class="value-item">
          <div class="value-icon">专</div>
          <h3>{{ $t('about.values.items.professional.title') }}</h3>
          <p>{{ $t('about.values.items.professional.desc') }}</p>
        </div>
        <div class="value-item">
          <div class="value-icon">诚</div>
          <h3>{{ $t('about.values.items.integrity.title') }}</h3>
          <p>{{ $t('about.values.items.integrity.desc') }}</p>
        </div>
        <div class="value-item">
          <div class="value-icon">共</div>
          <h3>{{ $t('about.values.items.win.title') }}</h3>
          <p>{{ $t('about.values.items.win.desc') }}</p>
        </div>
      </div>
    </section>

    <section id="contact-us" class="contact-info">
      <h2>{{ $t('about.contact.title') }}</h2>
      <div class="contact-grid">
        <div class="contact-item">
          <div class="contact-icon">
            <img src="@/assets/images/address-book.svg" alt="Address"/>
          </div>
          <h3>{{ $t('about.contact.address.title') }}</h3>
          <p>{{ $t('about.contact.address.content') }}</p>
        </div>
        <div class="contact-item">
          <div class="contact-icon">
            <img src="@/assets/images/phone.svg" alt="Phone"/>
          </div>
          <h3>{{ $t('about.contact.phone.title') }}</h3>
          <p>{{ $t('about.contact.phone.content') }}</p>
        </div>
        <div class="contact-item">
          <div class="contact-icon">
            <img src="@/assets/images/email.svg" alt="Email"/>
          </div>
          <h3>{{ $t('about.contact.email.title') }}</h3>
          <p>{{ $t('about.contact.email.content') }}</p>
        </div>
      </div>
      <img src="@/assets/images/company-pos.jpg" alt="Company Position" class="responsive-image" />
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  computed: {
    paragraphs() {
      return this.$t('about.intro.content').split('<br>');
    }
  }
}
</script>

<style scoped>
.about-page {
  background-color: var(--background-light);
  min-height: 100vh;
}

.about-hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  margin-bottom: 3rem;
}

.about-hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.about-hero p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.company-info,
.company-values,
.contact-info,
.company-image {
  max-width: 1200px;
  margin: 0 auto 4rem;
  padding: 0 2rem;
}

.info-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.info-content h2,
.company-values h2,
.contact-info h2,
.company-image h2 {
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
}

.info-content p {
  color: var(--text-secondary);
  margin-bottom: 1rem;
  line-height: 1.6;
  text-indent: 2em;
}

.values-grid,
.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.value-item,
.contact-item {
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  text-align: center;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.value-item:hover,
.contact-item:hover {
  transform: translateY(-5px);
  border-color: var(--primary-color);
}

.value-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
}

.contact-icon {
  margin-bottom: 1rem;
}

.value-item h3,
.contact-item h3 {
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.value-item p,
.contact-item p {
  color: var(--text-secondary);
  line-height: 1.6;
}

.company-image {
  text-align: center;
  padding: 4rem 2rem;
}

.company-image h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: var(--text-primary);
}

.responsive-image {
  width: 60%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  display: block;
  margin: 0 auto;
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .about-hero h1 {
    font-size: 2rem;
  }

  .values-grid,
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style> 